import React from 'react';
import { Chart } from 'primereact/chart';
import { chartOptions } from './options/chartOptions';

export default function SportChart({ sport, participantScores }) {
  const roundColor = (i) => `hsl(${(i * 60) % 360}, 70%, 50%)`;

  // Sort participants by score
  const sortedParticipants = [...participantScores].sort((a, b) => 
    sport.ascending ? a.score - b.score : b.score - a.score
  );

  let datasets;
  if (sport.combined) {
    datasets = [];
    for (let i = 0; i < sport.rounds; i++) {
      datasets.push({
        label: `Kierros ${i + 1}`,
        backgroundColor: roundColor(i),
        data: sortedParticipants.map(p => p.rounds[i]),
        stack: 'stack1',
      });
    }
  } else {
    datasets = [{
      label: 'Paras',
      backgroundColor: sortedParticipants.map(p => p.bestRoundIndex !== null ? roundColor(p.bestRoundIndex) : '#ccc'),
      data: sortedParticipants.map(p => p.score),
    }];
  }

  const data = {
    labels: sortedParticipants.map(p => p.name),
    datasets,
  };

  return (
    <Chart 
      type="bar" 
      data={data} 
      options={chartOptions({ ticks: !sport.time, stacked: sport.combined })} 
      style={{ marginBottom: "15px", height: "200px" }}
    />
  );
}
